import { AUTH_AUTO_SIGNIN, AUTH_SIGNOUT_REQUEST } from 'modules/auth/store/constants';

export const getAutoSignin = () => ({
  type: AUTH_AUTO_SIGNIN,
});

export const authSignoutRequest = () => ({
  type: AUTH_SIGNOUT_REQUEST,
});
